// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5b93e516","211":"a5441c95","638":"a5441c95","975":"7d53c2e8"}[chunkId] + ".chunk.css";
};